import template from './accountAdd.template.html';

export default {
  bindings: {
    onFinished: '&'
  },
  controller: class controller {
    constructor(
      $rootScope,
      $mdDialog,
      $mdMedia,
      eventService,
      accountService,
      uiService,
      Account
    ) {
      'ngInject';

      const ctrl = this;
      ctrl.$mdDialog = $mdDialog;
      ctrl.$mdMedia = $mdMedia;
      ctrl.destroyWatch = null;

      ctrl.initialize = () => {
        ctrl.destroyWatch = eventService.onAccountAdd((params) => {
          $mdDialog
            .show({
              targetEvent: params.event,
              locals: {
                account: Account.blank(),
                isPartner: params.isPartner
              },
              template,
              controllerAs: '$ctrl',
              controller(account, isPartner) {
                const self = this;
                self.account = account;
                self.isPartner = isPartner;
                self.isEnterprise = $rootScope.IsEnterprise;
                self.messages = [
                  `Each <strong>${
                    self.isPartner ? 'partner' : 'user'
                  }</strong> added to the organization will incur charges to your account`
                ];

                self.canSave = () =>
                  self.account?.user?.firstName &&
                  self.account?.user?.lastName &&
                  self.account?.user?.eMail;

                self.confirm = () => {
                  if (self.canSave()) {
                    $mdDialog.hide({ account: self.account, isPartner: self.isPartner });
                  } else {
                    uiService.toast({
                      text: {
                        p1: isPartner ? 'Partner' : 'User',
                        p2: 'first name, family name and E-Mail',
                        p3: 'are required'
                      },
                      warn: true
                    });
                  }
                };
                self.cancel = () => {
                  $mdDialog.cancel();
                };
              }
            })
            .then((res) => {
              const { isPartner } = res;
              accountService.createAccount(res.account, { isPartner }).then((data) => {
                if (data.status) {
                  res.account.id = data.id;
                  res.account.isNew = true;
                  ctrl.onFinished({ account: res.account });
                } else {
                  uiService.toast({
                    text: {
                      p1: params.isPartner ? 'Partner' : 'User',
                      p2: 'cannot be added',
                      p3: `he may already be present as a ${
                        params.isPartner ? 'user' : 'partner'
                      }`
                    },
                    warn: true
                  });
                }
              });
            });
        });
      };

      ctrl.$onInit = () => {
        ctrl.initialize();
      };

      ctrl.$onDestroy = () => {
        ctrl.destroyWatch();
      };
    }
  }
};
